var map = {
	"./COMPLETED/index.vue": 288,
	"./EXECUTIVE_ACTION/index.vue": 293,
	"./LEGISLATING/index.vue": 295,
	"./LOBBY/index.vue": 297,
	"./NOMINATING/index.vue": 298,
	"./VOTING/index.vue": 299
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 366;


//////////////////
// WEBPACK FOOTER
// ./src.player/ui/game-states ([\w-]+)\/index.vue$
// module id = 366
// module chunks = 0